module.exports = __webpack_public_path__ + "static/media/buanderie.8addd6b9.jpg";